module.exports = __webpack_public_path__ + "img/on-boarding-notifications.7c9982e4.png";